import { OpportunityProvider } from 'generated/graphql';

export const opportunityProviderNames: Record<OpportunityProvider, string> = {
  Betterplace: 'Betterplace',
  Catchafire: 'Catchafire',
  GlobalGiving: 'Global Giving',
  Goodera: 'Goodera',
  Idealist: 'Idealist',
  PointsOfLight: 'Points Of Light',
  VolunteerGov: 'Volunteer.gov',
  VolunteerMatch: 'Volunteer Match',
};
